import React, { useEffect } from "react";
import { TableComponent } from "../../../components/table/TableComponent";
import Text from "@amzn/meridian/text";
import { filtersByMailType } from "../../../features/filter-sheets/utils";
import { useTable } from "../../../components/table/hooks";
import { useSheets } from "../../../features/sheets/hooks";
import { Space } from "../../../components/space/Space";
import { useNavigate } from "react-router-dom";

interface MailsToPropertyProps {
    artifactType: string;
    artifactId: string;
    propertyNumber: string;
}

export const AssociatedParcels: React.FC<MailsToPropertyProps> = ({
    artifactType,
    artifactId,
    propertyNumber,
}) => {
    const { updateSheets } = useSheets();
    const { updateCurrentTable } = useTable();
    const navigate = useNavigate();

    useEffect(() => {
        updateSheets(filtersByMailType.parcel);
        updateCurrentTable("parcel");
    }, []);

    return (
        <>
            <Text type="h200">Parcels to this property</Text>
            <Space size="xs" />
            <TableComponent
                tableQueryParams={{
                    associatedArtifactId: artifactId,
                    associatedArtifactType: artifactType,
                }}
                tableUseCase="GET_ASSOCIATED_PARCELS"
                extraHelperButtons={[
                    {
                        props: { type: "secondary" },
                        label: "Add parcel",
                        actions: () => {
                            navigate(`/property-details/${artifactId}/add-parcel`, {
                                state: {
                                    propertyNumber: propertyNumber,
                                    artifactId: artifactId,
                                    artifactType: artifactType,
                                },
                            });
                        },
                    },
                ]}
            />
        </>
    );
};
